import type { KeyboardEvent, ReactNode } from 'react'
import ShellSelectMenuOption from './ShellSelectMenuOption'
import type { ShellSelectMenuItem } from './useShellSelect'
import { PoleMenu } from './styled-components'

interface ShellSelectMenuProps {
  labelId: string
  width: number
  items: ShellSelectMenuItem[]
  icon?: (size: number) => ReactNode
  onKeyDown: (event: KeyboardEvent<HTMLElement>) => void
}

const ShellSelectMenu = ({ labelId, width, items, icon, onKeyDown }: ShellSelectMenuProps) => (
  <PoleMenu role='listbox' aria-labelledby={labelId} $width={width} onKeyDown={onKeyDown}>
    {items.map(item => (
      <ShellSelectMenuOption key={item.id} item={item} icon={icon} />
    ))}
  </PoleMenu>
)

export default ShellSelectMenu
